import React, { useState } from 'react'
import ModalCustom from '../../../../components/modal/ModalCustom';
import InputTextField from '../../../../components/input/inputTextField';
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { styled } from '@mui/material';
import { alertSuccess } from '../../../../components/alert/swal';
import { EmployeeApi } from '../../../../api/employee/employee.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useParams } from 'react-router-dom';

const IconEye = styled(VisibilityOffOutlinedIcon)({
    transform: "rotate(-180deg)",
    cursor: "pointer",
    '&:hover': {
        opacity: 1
    }
})

type Props = {
    open: boolean;
    onClose: (status: boolean) => void;
    callback:()=>void;
}

const ModalEditPassword: React.FC<Props> = (props: Props) => {
    const { id} = useParams();
    const { open, onClose ,callback} = props;
    const dispatch = useDispatch();
    const [togglePassword, setTogglePassword] = useState<boolean>(false);
    const [confirmTogglePassword, setConfirmTogglePassword] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [formChangePassword, setFormChangePassword] = useState<{ password: string, confirmPassword: string }>({
        password: "",
        confirmPassword: ""
    })
    const handleChange = (name: string, value: string) => {
        setErrorMessage("");
        setFormChangePassword((prev) => ({ ...prev, [name]: value }));
    }
    const handleSubmit = async (id_employee:number) => {
        if (!formChangePassword.password) {
            return setErrorMessage("ระบุรหัสผ่านใหม่ที่ต้องการ");
        } else if (!formChangePassword.confirmPassword) {
            return setErrorMessage('ระบุรหัสผ่านใหม่ที่ต้องการ');
        } else if (formChangePassword.password !== formChangePassword.confirmPassword) {
            return setErrorMessage("รหัสผ่านไม่ตรงกัน");
        }
        const body: {
            new_password: string;
            confirm_password: string;
        } = {
            new_password: formChangePassword.password,
            confirm_password: formChangePassword.confirmPassword
        }
        dispatch(setLoading());
        await EmployeeApi.resetPassword(id_employee,body).then((res) => {
            if (res.status < 300) {
                alertSuccess('แก้ไขรหัสผ่าน', 'แก้ไขรหัสผ่าน เรียบร้อยแล้ว', undefined, () => {
                    onClose(false);
                })
            }
        }).catch((error) => console.log(error))
            .finally(() => {
                callback();
            })

    }
    return (
        <ModalCustom
            title='แก้ไขรหัสผ่าน'
            subTitle='กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน'
            open={open}
            onClose={() => {
                onClose(false);
            }}
            component={
                <section className='grid grid-cols-12 gap-y-6'>
                    <article className='col-span-12'>
                        <InputTextField
                            value={formChangePassword.password}
                            helperText={errorMessage}
                            type={togglePassword ? 'text' : 'password'}
                            heading='รหัสผ่านใหม่'
                            placeholder='ระบุรหัสผ่านใหม่'
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('password', e.target.value)}
                            endAdornment={<IconEye onClick={() => setTogglePassword(!togglePassword)} sx={{ opacity: !togglePassword ? .3 : 1 }} />}
                        />
                    </article>
                    <article className='col-span-12'>
                        <InputTextField
                            value={formChangePassword.confirmPassword}
                            helperText={errorMessage}
                            type={confirmTogglePassword ? 'text' : 'password'}
                            placeholder='ยืนยันรหัสผ่านใหม่อีกครั้ง'
                            heading='ยืนยันรหัสผ่านใหม่อีกครั้ง'
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('confirmPassword', e.target.value)}
                            endAdornment={<IconEye onClick={() => setConfirmTogglePassword(!confirmTogglePassword)} sx={{ opacity: !confirmTogglePassword ? .3 : 1 }} />}
                        />
                    </article>
                    <article className='col-span-12 flex items-center justify-center gap-4 my-4'>
                        <ButtonOutlined
                            onClick={() => {
                                onClose(false);
                                setErrorMessage("");
                                setFormChangePassword({
                                    password: "",
                                    confirmPassword: ""
                                })
                            }}
                            mode='del'
                            buttonName='ยกเลิก'
                        />
                        <ButtonPrimary
                            disabled={!formChangePassword.password || !formChangePassword.confirmPassword}
                            onClick={() => id && handleSubmit(+id)}
                            mode='success'
                            buttonName='ยืนยัน'
                        />
                    </article>
                </section>
            }
        />
    )
}

export default ModalEditPassword